//src/styles/typography/index.js
/**
 * Typography System
 * Central configuration for all typography-related styles
 */

import palette from "../palette";
import { getFontFamily } from "./fonts";
import { fontSize } from "./sizes";
import { fontWeight } from "./weights";
import { lineHeight } from "./lineHeights";

// Re-export everything for convenience
export * from "./fonts";
export * from "./sizes";
export * from "./weights";
export * from "./lineHeights";

// Typography configuration for Material-UI theme
const typography = {
  fontFamily: getFontFamily(),
  fontSize: 16,
  fontWeightLight: fontWeight.light,
  fontWeightRegular: fontWeight.regular,
  fontWeightMedium: fontWeight.medium,
  fontWeightBold: fontWeight.bold,
  letterSpacing: "0.03em",

  h1: {
    color: palette.primary.main,
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize["6xl"],
    lineHeight: lineHeight.tight,
    fontFamily: getFontFamily(),
    letterSpacing: "-0.02em",
  },
  h2: {
    color: palette.primary.main,
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize["5xl"],
    lineHeight: lineHeight.snug,
    fontFamily: getFontFamily(),
    letterSpacing: "0.02em",
    textTransform: "capitalize",
  },
  h3: {
    color: palette.text.primary,
    fontWeight: fontWeight.medium,
    fontSize: fontSize["4xl"],
    lineHeight: lineHeight.normal,
    fontFamily: getFontFamily(),
    textTransform: "capitalize",
  },
  h4: {
    color: palette.text.primary,
    fontWeight: fontWeight.medium,
    fontSize: fontSize["3xl"],
    lineHeight: lineHeight.normal,
    fontFamily: getFontFamily(),
  },
  h5: {
    color: palette.primary.main,
    fontWeight: fontWeight.medium,
    fontSize: fontSize["2xl"],
    lineHeight: lineHeight.normal,
    fontFamily: getFontFamily(),
  },
  h6: {
    color: palette.text.primary,
    fontWeight: fontWeight.medium,
    fontSize: fontSize.xl,
    lineHeight: lineHeight.normal,
    fontFamily: getFontFamily(),
    textTransform: "capitalize",
  },

  subtitle1: {
    color: palette.text.primary,
    fontWeight: fontWeight.regular,
    fontSize: fontSize.lg,
    lineHeight: lineHeight.relaxed,
    fontFamily: getFontFamily(),
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: fontWeight.regular,
    fontSize: fontSize.base,
    lineHeight: lineHeight.relaxed,
    fontFamily: getFontFamily(),
  },

  body1: {
    color: palette.text.primary,
    fontSize: fontSize.base,
    fontWeight: fontWeight.regular,
    lineHeight: lineHeight.relaxed,
    fontFamily: getFontFamily(),
    //textTransform: "capitalize",   // First Letter Of Each Word Capitalized
  },
  body2: {
    color: palette.text.secondary,
    fontSize: fontSize.sm,
    fontWeight: fontWeight.regular,
    lineHeight: lineHeight.relaxed,
    fontFamily: getFontFamily(),
    ///textTransform: "capitalize",   // First Letter Of Each Word Capitalized
  },

  button: {
    textTransform: "none",
    fontWeight: fontWeight.medium,
    fontSize: fontSize.base,
    lineHeight: lineHeight.button,
    fontFamily: getFontFamily(),
    letterSpacing: "0.02em",
  },

  caption: {
    color: palette.text.tertiary,
    fontSize: fontSize.xs,
    fontWeight: fontWeight.regular,
    lineHeight: lineHeight.caption,
    fontFamily: getFontFamily(),
  },

  overline: {
    color: palette.text.tertiary,
    fontSize: "0.625rem",
    fontWeight: fontWeight.medium,
    textTransform: "uppercase",
    lineHeight: lineHeight.caption,
    fontFamily: getFontFamily(),
    letterSpacing: "0.1em",
  },

  display1: {
    fontSize: fontSize["7xl"],
    fontWeight: fontWeight.bold,
    lineHeight: lineHeight.none,
    color: palette.primary.main,
  },
  display2: {
    fontSize: fontSize["6xl"],
    fontWeight: fontWeight.semiBold,
    lineHeight: lineHeight.tight,
    color: palette.primary.dark,
  },
  lead: {
    fontSize: fontSize.lg,
    fontWeight: fontWeight.light,
    lineHeight: lineHeight.relaxed,
    color: palette.text.secondary,
  },
  whizText1: {
    color: palette.text.primary,
    fontSize: fontSize.base,
    fontWeight: fontWeight.regular,
    lineHeight: lineHeight.relaxed,
    fontFamily: getFontFamily(),
    textTransform: "capitalize",   // First Letter Of Each Word Capitalized
  },
  whizText2: {
    color: palette.text.secondary,
    fontSize: fontSize.sm,
    fontWeight: fontWeight.regular,
    lineHeight: lineHeight.relaxed,
    fontFamily: getFontFamily(),
    textTransform: "capitalize",   // First Letter Of Each Word Capitalized
  },
};

export default typography;